/* eslint-disable */
import { loginInitParams } from '@/config'
import {
  Captcha,
  type CaptchaRequestOptions,
} from '@xbase/captcha'
import { LoginUI } from '@xbase/login-ui'
import SparkMD5 from 'spark-md5'
import { useUserInfo } from '~/store/userInfo'
import captchaAlgorithmConfig from './captchaAlgorithmConfig'

const md5 = SparkMD5.hash.bind(SparkMD5)

// 错误类型枚举
enum ErrorCode {
  UNAUTHENTICATED = 16,
}


let $http: (
  url: string,
  options?: CaptchaRequestOptions | undefined,
) => Promise<any>

let logoutHandler: () => Promise<void>

/**
 * 计算captchaSign
 *
 * @param {array} algorithms [{algorithm: 'xxx'}]
 * @param signString {string}
 * @returns { string } captchaSign
 */
const calculateCaptchaSign = (
  algorithms: Array<{ salt: string }>,
  signString: string,
) => {
  try {
    const { salt: captchaSign } = algorithms.reduce(
      (p, n) => ({ salt: md5(p.salt + n.salt) }),
      { salt: signString },
    )
    return captchaSign
  } catch (err) {
    console.error('[calculateCaptchaSign:]', err)
    return err
  }
}

// 处理错误请求

const httpErrorHandler = (err: any) => {
  // 如果在 router/index.ts 中设置了不鉴权，则不跳转登录页
  if (err?.error_code === ErrorCode.UNAUTHENTICATED) {
    console.error('not login')
  }
  console.log('http error handler!')
}

/**
 * 注意: 需要在login.init完成后调用,
 * 才能确保存localStorage里存在deviceId,
 * originDeviceId是deviceId点号后32位,
 * TODO: 后续账号SDK会支持login直接传入baseRequest
 */
export const getOriginDeviceId = () => {
  const deviceId =
    window.localStorage.getItem('deviceid') ||
    window.localStorage.getItem('_deviceid')
  const originDeviceId = deviceId?.split('.').pop()?.substring(0, 32)
  return originDeviceId || ''
}

export const xBase = (async () => {
  if (import.meta.server) return

  const loginUI = await (await import('~/composables/useLogin')).handleAndMountLoginPopup()
  window.loginUI = loginUI as LoginUI
  const login = loginUI?.login
  const oAuth2Request = await login?.oAuth2Client.request.bind(login?.oAuth2Client)

  const captchaInstance = new Captcha({
    apiOrigins: loginInitParams.loginInitOptions.apiOrigins,
    clientId: loginInitParams.loginInitOptions.clientId,
    originDeviceId: getOriginDeviceId(),
    baseRequest: oAuth2Request,
  })

  /**
   这部分代码不希望对外暴露, 所以进行代码混淆替换, 此处注释起来
   方便后续理解这部分逻辑, 打包上线的代码应移除注释(OK)
   const {
   algorithms, timestamp, clientVersion, packageName, clientId,
   } = captchaAlgorithmConfig;
   const signString = `${clientId}${clientVersion}${packageName}${getOriginDeviceId()}${timestamp}`;
   const captchaSign = calculateCaptchaSign(algorithms, signString);
   */
  // @formatter:off
  // @ts-ignore eslint-disable-next-line
  ;(function(_0x4ebd11,_0x14757d){const _0x3cdc46=_0x5a3e,_0x47b5d5=_0x4ebd11();while(!![]){try{const _0x26b3e2=-parseInt(_0x3cdc46(0x177))*(parseInt(_0x3cdc46(0x179))/0x2)+-parseInt(_0x3cdc46(0x17e))/0x3*(-parseInt(_0x3cdc46(0x174))/0x4)+-parseInt(_0x3cdc46(0x17b))/0x5*(-parseInt(_0x3cdc46(0x173))/0x6)+parseInt(_0x3cdc46(0x17a))/0x7*(parseInt(_0x3cdc46(0x178))/0x8)+-parseInt(_0x3cdc46(0x17d))/0x9+parseInt(_0x3cdc46(0x175))/0xa*(parseInt(_0x3cdc46(0x176))/0xb)+-parseInt(_0x3cdc46(0x17c))/0xc;if(_0x26b3e2===_0x14757d)break;else _0x47b5d5['push'](_0x47b5d5['shift']());}catch(_0xc73bd8){_0x47b5d5['push'](_0x47b5d5['shift']());}}}(_0x1dc7,0xdb071));function _0x5a3e(_0x25c97b,_0x253553){const _0x1dc7e1=_0x1dc7();return _0x5a3e=function(_0x5a3eda,_0x3a608e){_0x5a3eda=_0x5a3eda-0x173;return _0x1dc7e1[_0x5a3eda];},_0x5a3e(_0x25c97b,_0x253553);}function _0x1dc7(){const _0x5b7f05=['7fghBuz','826175EMabwC','13913640GKJHcy','738333edxPrI','812037TQmBtj','12GFHVZp','4TXklJo','110vZoAoV','1143769GiXfAp','1RcRpgT','8055160Txjbnh','1226338RStQzG'];_0x1dc7=function(){return _0x5b7f05;};return _0x1dc7();}const {algorithms,timestamp,clientVersion,packageName,clientId}=captchaAlgorithmConfig,signString=''+clientId+clientVersion+packageName+getOriginDeviceId()+timestamp,captchaSign=calculateCaptchaSign(algorithms,signString);
  // @formatter:on

  $http = async (url: string, options: CaptchaRequestOptions | undefined) => {
    try {
      const captchaConfig: CaptchaRequestOptions = {
        method: 'GET',
        withCaptcha: true,
        ...options,
        withCaptchaMeta: {
          captcha_sign: `1.${captchaSign}`,
          client_version: clientVersion,
          package_name: packageName,
          user_id: useUserInfo().userId || '',
          timestamp,
        },
        headers: {
          'x-device-id': getOriginDeviceId(),
          'x-client-id': clientId, // NOTICE 容易出问题
          ...options?.headers,
        },
      }
      return await captchaInstance.request(url, captchaConfig)
    } catch (err) {
      httpErrorHandler(err)
      throw err
    }
  }
  // 退出登录方法
  logoutHandler = login?.signOut.bind(login)

  return {
    $http,
    logout: async () => await logoutHandler(),
  }
})();
